import React, { useState, useEffect, useRef } from 'react'
import { useAuthState } from "react-firebase-hooks/auth"
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api"
import { db, storage, auth } from "../../assets/js/firebase"
import { collection, query, where, getDocs, updateDoc, doc, orderBy } from 'firebase/firestore'
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import { sendEmailVerification } from "firebase/auth"

import { useNavigate } from "react-router-dom"
import { BsPersonVcard } from "react-icons/bs"
import { TbHome } from 'react-icons/tb'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { RiBankCardLine } from 'react-icons/ri'
import { IoCloseCircle, IoCheckmarkCircleSharp } from "react-icons/io5"
import { FiMail } from "react-icons/fi"
import LeftMenu from './LeftMenu'
import addImage from "../../assets/images/add-image-icon.png"

import { IoMdMenu } from "react-icons/io"
import logo from "../../assets/images/weee-logo.png"
import Drawer from '@mui/material/Drawer'
import Box from '@mui/material/Box'

import { Loading } from "../layouts/Loading"
import { defaultLatLng, googleMapsApiKey } from "../../../assets/constants/locations"

const EditProfile = () => {
    const navigate = useNavigate()
    const [user, loading] = useAuthState(auth)

    const [showLoading, setShowLoading] = useState(false)
    const [showResend, setShowResend] = useState(false)
    const [openDrawer, setOpenDrawer] = useState(false)

    const [uid, setUid] = useState('')
    const [member, setMember] = useState([])
    const [memberId, setMemberId] = useState('')
    const [isShop, setIsShop] = useState(0)

    const [imageProfile, setImageProfile] = useState('')
    const [imageProfileUrl, setImageProfileUrl] = useState(addImage)
    const [displayName, setDisplayName] = useState('')
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [telNo, setTelNo] = useState('')
    const [lat, setLat] = useState(defaultLatLng.lat)
    const [lng, setLng] = useState(defaultLatLng.lng)
    const [idCard, setIdCard] = useState('')
    const [idCardUrl, setIdCardUrl] = useState('')
    const [bankId, setBankId] = useState(0)
    const [bankAccNo, setBankAccNo] = useState('')
    const [bookBank, setBookBank] = useState('');
    const [bookBankUrl, setBookBankUrl] = useState('')

    const inputIdCardRef = useRef(null)
    const inputBookBankRef = useRef(null)

    const [address, setAddress] = useState('')
    const [road, setRoad] = useState('')
    const [postcode, setPostcode] = useState('')

    const [subroad, setSubRoad] = useState('')
    const [village, setVillage] = useState('')
    const [building, setBuilding] = useState('')
    const [floor, setFloor] = useState('')
    const [room, setRoom] = useState('')

    const [displayNameErrorDiv, setDisplayNameErrorDiv] = useState(false)
    const [firstnameErrorDiv, setFirstnameErrorDiv] = useState(false)
    const [lastnameErrorDiv, setLastnameErrorDiv] = useState(false)
    const [telNoErrorDiv, setTelNoErrorDiv] = useState(false)
    const [bankIdErrorDiv, setBankIdErrorDiv] = useState(false)
    const [bankAccNoErrorDiv, setBankAccNoErrorDiv] = useState(false)

    const [imageProfileSizeError, setImageProfileSizeError] = useState(false)
    const [imageIdCardSizeError, setImageIdCardSizeError] = useState(false)
    const [imageBookBankSizeError, setImageBookBankSizeError] = useState(false)
    const [showProgressBar, setShowProgressBar] = useState(false)

    const [bankList, setBankList] = useState([])
    const [provinceList, setProvinceList] = useState([])
    const [provinceId, setProvinceId] = useState(0)
    const [districtList, setDistrictList] = useState([])
    const [districtId, setDistrictId] = useState(0)
    const [subdistrictList, setSubDistrictList] = useState([])
    const [subdistrictId, setSubDistrictId] = useState(0)

    const [provinceIdErrorDiv, setProvinceIdErrorDiv] = useState(false)
    const [districtIdErrorDiv, setDistrictIdErrorDiv] = useState(false)
    const [subdistrictIdErrorDiv, setSubDistrictErrorDiv] = useState(false)

    const [currentLat, setCurrentLat] = useState(0)
    const [currentLng, setCurrentLng] = useState(0)

    const { isLoaded } = useLoadScript({ googleMapsApiKey: googleMapsApiKey })
    const [center, setCenter] = useState({ lat: defaultLatLng.lat, lng: defaultLatLng.lng })
    const onMarkerDragEnd = (lat, lng) => {
        setLat(lat)
        setLng(lng)
    }

    function isSpecialChar(text) {
        return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(text)
    }

    function isOnlyNumeric(text) {
        return /^[0-9\b]+$/.test(text)
    }

    const validateForm = () => {
        if(!displayName || isSpecialChar(displayName)) {
            setDisplayNameErrorDiv(true)
            return false
        } else {
            setDisplayNameErrorDiv(false)
        }

        if(!firstname || isSpecialChar(firstname)) {
            setFirstnameErrorDiv(true)
            return false
        } else {
            setFirstnameErrorDiv(false)
        }

        if(!lastname || isSpecialChar(lastname)) {
            setLastnameErrorDiv(true)
            return false
        } else {
            setLastnameErrorDiv(false)
        }

        if(!telNo || !isOnlyNumeric(telNo)) {
            setTelNoErrorDiv(true)
            return false
        } else {
            setTelNoErrorDiv(false)
        }

        /* if(bankId == 0) {
            setBankIdErrorDiv(true)
            return false;
        } else {
            setBankIdErrorDiv(false)
        }

        if(!bankAccNo || !isOnlyNumeric(bankAccNo)) {
            setBankAccNoErrorDiv(true)
            return false;
        } else {
            setBankAccNoErrorDiv(false)
        } */

        if(provinceId == 0) {
            setProvinceIdErrorDiv(true)
            return false
        } else {
            setProvinceIdErrorDiv(false)
        }

        if(districtId == 0) {
            setDistrictIdErrorDiv(true)
            return false
        } else {
            setDistrictIdErrorDiv(false)
        }

        if(subdistrictId == 0) {
            setSubDistrictErrorDiv(true)
            return false
        } else {
            setSubDistrictErrorDiv(false)
        }
        return true
    }

    const handleImageProfile = (file) => {
        if(file.size > 1 * 1000 * 1024) {
            setImageProfileSizeError(true)
        } else {
            setImageProfileUrl(URL.createObjectURL(file))
            setImageProfile(file)
            setImageProfileSizeError(false)
        }
    }

    const handleImageIdCard = (file) => {
        if(file.size > 1 * 1000 * 1024) {
            setImageIdCardSizeError(true)
        } else {
            setIdCardUrl(URL.createObjectURL(file))
            setIdCard(file)
            setImageIdCardSizeError(false)
        }
    }

    const handleImageBookBank = (file) => {
        if(file.size > 1 * 1000 * 1024) {
            setImageBookBankSizeError(true)
        } else {
            setBookBankUrl(URL.createObjectURL(file))
            setBookBank(file)
            setImageIdCardSizeError(false)
        }
    }

    const handleSubmit = async (e) => {
    	e.preventDefault()
        if(validateForm()) {
            updateDoc(doc(db, 'users', memberId), {
                display_name: displayName,
                firstname: firstname,
                lastname: lastname,
                tel_no: telNo,
                address: address,
                road: road,
                subroad: subroad,
                village: village,
                building: building,
                floor: floor,
                room: room,
                sub_district: subdistrictId,
                district: districtId,
                province: provinceId,
                postcode: postcode,
                lat: lat,
                lng: lng,
                bank_id: bankId,
                bank_account_no: bankAccNo,
            }).then(() => {
                var promisesFile = []
                if(bookBank) {
                    const bookbankRef = ref(storage, `/users/${memberId}/image/bookbank/${bookBank.name}`)
                    const bookbankTask = uploadBytesResumable(bookbankRef, bookBank)
                    promisesFile.push(bookbankTask)
                    bookbankTask.on( "state_changed",
                        () => { },
                        (err) => console.log(err),
                        () => { 
                            getDownloadURL(bookbankTask.snapshot.ref).then((url) => {
                                updateDoc(doc(db, `users`, memberId), {
                                    book_bank: url,
                                })
                            })
                        }
                    )
                }
                if(idCard) {
                    const idCardRef = ref(storage, `/users/${memberId}/image/idcard/${idCard.name}`)
                    const idCardTask = uploadBytesResumable(idCardRef, idCard)
                    promisesFile.push(idCardTask)
                    idCardTask.on( "state_changed",
                        () => { },
                        (err) => console.log(err),
                        () => { 
                            getDownloadURL(idCardTask.snapshot.ref).then((url) => {
                                updateDoc(doc(db, `users`, memberId), {
                                    id_card: url,
                                })
                            })
                        }
                    )
                }
                if(imageProfile) {
                    const imageRef = ref(storage, `/users/${memberId}/image/profile/${imageProfile.name}`)
                    const imageTask = uploadBytesResumable(imageRef, imageProfile)
                    promisesFile.push(imageTask)
                    imageTask.on( "state_changed",
                        () => { },
                        (err) => console.log(err),
                        () => { 
                            getDownloadURL(imageTask.snapshot.ref).then((url) => {
                                updateDoc(doc(db, `users`, memberId), {
                                    image_profile: url,
                                })
                            })
                        }
                    )
                }

                Promise.all(promisesFile).then(() => {
                    setShowProgressBar(false)
                    navigate(`/profile`)
                })
            }).then(() => {
            }).catch((error) => {
                console.log(error)
            })
        }
    }

    const getBankList = () => {
        getDocs(query(collection(db, 'banks'), orderBy('order', 'asc'))).then((docs) => {
            setBankList(docs.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }

    const getProvince = () => {
        getDocs(query(collection(db, 'provinces'), orderBy('province_id', 'asc'))).then((docs) => {
            setProvinceList(docs.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }

    const handleSelectProvince = (provinceId) => {
        setProvinceId(provinceId)

        setDistrictId(0)
        districtList.splice(0, districtList.length)
        setDistrictList([...districtList])

        setSubDistrictId(0)
        subdistrictList.splice(0, subdistrictList.length)
        setSubDistrictList([...subdistrictList])
        setPostcode('')

        getDocs(query(collection(db, 'distrincts'), where('province_id', '==', provinceId*1), orderBy('province_id', 'asc'))).then((docs) => {
            setDistrictList(docs.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }

    const handleSelectDistrict = (districtId) => {
        setDistrictId(districtId)

        setSubDistrictId(0)
        subdistrictList.splice(0, subdistrictList.length)
        setSubDistrictList([...subdistrictList])
        setPostcode('')

        getDocs(query(collection(db, 'subdistrincts'), where('district_id', '==', districtId), orderBy('district_id', 'asc'))).then((docs) => {
            setSubDistrictList(docs.docs.map(doc => ({
                id: doc.id,
                data: doc.data()
            })))
        })
    }

    const handelSelectsubDistrict = (subdistrictId) => {
        setSubDistrictId(subdistrictId)
        setPostcode('')
        getDocs(query(collection(db, 'postcodes'), where('subdistrict_id', '==', subdistrictId*1))).then((docs) => {
            setPostcode(docs.docs[0].data().postcode)
        })
    }

    const handleGoToCurrentPosition = () => {
        setLat(currentLat)
        setLng(currentLng)
        setCenter({ lat: currentLat, lng: currentLng })
    }

    const handleReSendVerifyEmail = async () => {
        setShowResend(true)
        await sendEmailVerification(auth.currentUser).then(() => {
            setShowResend(false)
        })
    }

    var locationOptions = {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 0,
    }

    const locationSuccess = (pos) => {
        var crd = pos.coords
        setCurrentLat(crd.latitude)
        setCurrentLng(crd.longitude)
    }

    const locationErrors = (err) => {
        console.warn(`ERROR(${err.code}): ${err.message}`)
    }

    const getDocUser = () => {
        getDocs(query(collection(db, "users"), where("uid", "==", user.uid))).then((docs) => {
            if (docs.docs.length === 1) {
                const memberData = docs.docs[0].data()
                setUid(user.uid)
                setMemberId(docs.docs[0].id)
                setMember(memberData)

                if(memberData.is_shop) setIsShop(memberData.is_shop)

                var promisesTask = []
                if(memberData.province) {
                    const districtTask = getDocs(query(collection(db, 'distrincts'), where('province_id', '==', memberData.province * 1))).then((docs) => {
                        setDistrictList(docs.docs.map(doc => ({
                            id: doc.id,
                            data: doc.data()
                        })))
                    })
                    promisesTask.push(districtTask)
                }

                if(memberData.district) {
                    const subdistrictTask = getDocs(query(collection(db, 'subdistrincts'), where('district_id', '==', memberData.district))).then((docs) => {
                        setSubDistrictList(docs.docs.map(doc => ({
                            id: doc.id,
                            data: doc.data()
                        })))
                    })
                    promisesTask.push(subdistrictTask)
                }
                if(memberData.image_profile) setImageProfileUrl(memberData.image_profile)

                if(memberData.display_name) setDisplayName(memberData.display_name)
                if(memberData.firstname) setFirstname(memberData.firstname)
                if(memberData.lastname) setLastname(memberData.lastname)
                if(memberData.tel_no) setTelNo(memberData.tel_no)
                if(memberData.id_card) setIdCardUrl(memberData.id_card)

                if(memberData.bank_account_no) setBankAccNo(memberData.bank_account_no)
                if(memberData.bank_id) setBankId(memberData.bank_id)
                if(memberData.book_bank) setBookBankUrl(memberData.book_bank)

                if(memberData.address) setAddress(memberData.address)
                if(memberData.village) setVillage(memberData.village)
                if(memberData.building) setBuilding(memberData.building)
                if(memberData.floor) setFloor(memberData.floor)
                if(memberData.room) setRoom(memberData.room)
                if(memberData.subroad) setSubRoad(memberData.subroad)
                if(memberData.road) setRoad(memberData.road)
                setProvinceId(memberData.province)
                setDistrictId(memberData.district)
                setSubDistrictId(memberData.sub_district)
                setPostcode(memberData.postcode)

                setLat(memberData.lat)
                setLng(memberData.lng)
                setCenter({lat: memberData.lat, lng: memberData.lng})

                Promise.all(promisesTask).then(() => {
                    setShowLoading(false)
                })
            }
        }).then(() => {
        }).catch((error) => {
            alert(error.message)
        })
    }
    
    const toggleDrawer = (newOpen) => () => {
        setOpenDrawer(newOpen)
    }
    
    useEffect(() => {
        if (loading) return
        if (!user) {
            return navigate("/")
        } else {
            setShowLoading(true)
            getDocUser()
            getBankList()
            getProvince()
        }
    }, [user, loading])

    useEffect(() => {
        if (navigator.geolocation) {
          navigator.permissions.query({ name: "geolocation" }).then(function (result) {
                //console.log(result);
                if (result.state === "granted") {
                //If granted then you can directly call your function here
                navigator.geolocation.getCurrentPosition(locationSuccess, locationErrors, locationOptions);
                } else if (result.state === "prompt") {
                //If prompt then the user will be asked to give permission
                navigator.geolocation.getCurrentPosition(locationSuccess, locationErrors, locationOptions);
                } else if (result.state === "denied") {
                //If denied then you have to show instructions to enable location
                }
            });
        } else {
          //console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    return (
    <>
        <Loading open={showLoading} text={"กำลังเรียกข้อมูล กรุณารอสักครู่"} />
        <Loading open={showProgressBar} text={"กำลังทำการบันทึกข้อมูล กรุณารอสักครู่"} />
        <Loading open={showResend} text={"กำลังทำการส่ง Email ยืนยัน กรุณารอสักครู่"} />
        <Drawer open={openDrawer} onClose={toggleDrawer(false)}>
            <Box sx={{ width: 280 }} role="presentation">
                <div style={{ display: 'flex', flexDirection: 'column', width: 250, marginLeft: 20 }}>
                    <div style={{ display: 'flex', flexDirection: 'column', width: 250, paddingTop: 15, paddingLeft: 10 }}>
                        <div style={{ marginBottom: 10 }}>
                            <a className="navbar-brand" href="/"><img src={logo} className="" style={{ height: 40 }} alt="WEEE" /></a>
                        </div>
                        <LeftMenu currentPage="profile" isShop={isShop} />
                    </div>
                </div>
            </Box>
        </Drawer>
        <div style={{ backgroundColor: "#fcfcfc", minHeight: 500, padding: 10}}>
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, marginRight: 20, marginBottom: 30 }}>
                <div style={{ paddingLeft: 20, marginBottom: 10, borderBottom: '1px solid #cccccc' }} className="d-none d-md-block d-lg-block"><h4><b>ข้อมูลส่วนตัว</b></h4></div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', borderRight: '1px solid #cccccc', marginRight: 20 }} className="d-none d-md-block d-lg-block">  
                        <LeftMenu currentPage="profile" isShop={isShop} />
                    </div>
                    {!showLoading && 
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                        <div className='d-block d-md-none d-lg-none' style={{ display: 'flex', fleDirection: 'row', marginBottom: 5, borderBottom: '1px solid #cccccc', paddingBottom: 5 }}>
                            <div style={{ display: 'flex', flexDisplay: 'column', alignmentBaseline: 'baseline' }}>
                                <button type="button" className="btn btn-primary" onClick={toggleDrawer(true)}><IoMdMenu style={{ fontSize: 25, marginRight: 5 }} />เมนูผู้ใช้</button>
                            </div>
                        </div>
                        <div className="flex-container" style={{ display: 'flex', borderBottom: '1px solid #cccccc', marginBottom: 10}}>
                            <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                                <h4 style={{ display: 'flex', flex: 1}}><BsPersonVcard style={{ fontSize: 30, marginRight: 10 }} />
                                <b>แก้ไขข้อมูลผู้ใช้</b></h4>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: 5}}>
                                <div style={{ float: 'right' }}>
                                    <button type="button" className="btn btn-success btn-sm" style={{ marginRight: 5, display: 'flex' }} onClick={handleSubmit}>
                                        <IoCheckmarkCircleSharp style={{ fontSize: 20, marginRight: 5 }} />บันทึก
                                    </button>
                                </div>
                                <div style={{ float: 'right' }}>
                                    <button type="button" className="btn btn-danger btn-sm" style={{ marginRight: 5, display: 'flex' }} onClick={() => { return navigate(`/profile`) }}>
                                        <IoCloseCircle style={{ fontSize: 20, marginRight: 5 }} />ยกเลิก
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="flex-container" style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', width: 170, marginBottom: 20}}>
                                <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems:'center' }}>
                                    <img src={imageProfileUrl} alt="WEEE" width="150" style={{ marginBottom: 5 }} />
                                    <div style={{ display: "flex", flexDirection:'row' }}>
                                        <label htmlFor="fileProfileUpload" style={{ padding: 0 }}>
                                            <a className='btn btn-primary btn-sm'>เลือกรูป</a>
                                        </label>
                                    </div>
                                    {imageProfileSizeError &&
                                    <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                        <strong>** ขนาดรูปภาพต้องไม่เกิน 1MB</strong>
                                    </div>
                                    }
                                    <input style={{ display:'none' }} className="form-control file" id="fileProfileUpload" type="file" accept="image/*" onChange={(e) => handleImageProfile(e.target.files[0])} />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 5}}>
                                <div style={{ marginBottom: 10, paddingTop: 5, borderBottom: '1px solid #cccccc' }}>
                                    <h6><BsPersonVcard style={{ fontSize: 25, marginRight: 5, paddingBottom: 5 }} />
                                    <b>ข้อมูลส่วนตัว</b></h6>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingRight: 15}}>
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>การยืนยัน Email</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            {user?(user.emailVerified?
                                                (<font className='text-success'>ยืนยัน</font>):
                                                (
                                                    <>
                                                        <font className='text-danger'>ยังไม่ยืนยัน</font>
                                                        <div style={{ float: 'right' }}>
                                                            <button type="button" className="btn btn-warning btn-sm" style={{ marginRight: 5, display: 'flex' }} onClick={() => { handleReSendVerifyEmail() }}>
                                                                <FiMail style={{ fontSize: 20, marginRight: 5 }} />ส่ง email ยืนยันอีกครั้ง
                                                            </button>
                                                        </div>
                                                    </>
                                                )):''}</div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ชื่อผู้ใช้ <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='displayName' onChange={(e) => setDisplayName(e.target.value)} 
                                                value={displayName} placeholder='ชื่อผู้ใช้'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1 }} />
                                            {displayNameErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณากรอกชื่อผู้ใช้ และไม่มีอักขระพิเศษ</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ชื่อ <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='firstname' onChange={(e) => setFirstname(e.target.value)} 
                                                value={firstname} placeholder='ชื่อ'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1 }} />
                                            {firstnameErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณากรอกชื่อ และไม่มีอักขระพิเศษ</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>นามสกุล <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='lastname' onChange={(e) => setLastname(e.target.value)} 
                                                value={lastname} placeholder='นามสกุล'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1 }} />
                                            {lastnameErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณากรอกนามสกุล และไม่มีอักขระพิเศษ</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>เบอร์โทรศัพท์ <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='telNo' onChange={(e) => setTelNo(e.target.value)} 
                                                value={telNo} placeholder='เบอร์โทรศัพท์'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1 }} />
                                            {telNoErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณากรอกเบอร์โทรศัพท์ (เฉพาะตัวเลขเท่านั้น)</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4}}><strong>สำเนาบัตรประชาชน</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            {idCardUrl &&
                                            <a href={idCardUrl} target='_blank' style={{ marginBottom: 5, marginLeft: 5}}><img src={idCardUrl} alt="WEEE" className='img-fluid' style={{ width: 200 }} /></a>
                                            }
                                            <input ref={inputIdCardRef} className="form-control file" id="idcard_image" type="file" accept="image/*" onChange={(e) => handleImageIdCard(e.target.files[0])} />
                                            {imageIdCardSizeError &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** ขนาดรูปภาพต้องไม่เกิน 1MB</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                </div>
                                <div style={{ marginBottom: 10, paddingTop: 13, borderBottom: '1px solid #cccccc', borderTop: '1px solid #cccccc', marginTop: 15 }}>
                                    <h6><RiBankCardLine style={{ fontSize: 25, marginRight: 5, paddingBottom: 5 }} />
                                    <b>บัญชีธนาคาร</b></h6>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingRight: 15}}>
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ธนาคาร{/*  <font className="text-danger">*</font> */}</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <select name='bankList' value={bankId} onChange={(e) => { setBankId(e.target.value) }} style={{ display: 'flex', paddingLeft: 8, paddingRight: 8, marginRight: 5, maxWidth: 250 }}>
                                                <option value="0">--- กรุณาเลือกธนาคาร ---</option>
                                                {bankList?.map((bank, i) => (
                                                <option value={bank.id} key={bank.id}>
                                                    {bank.data.bank_name_th} ({bank.data.bank_name_short})
                                                </option>
                                                ))}
                                            </select>
                                            {bankIdErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณาเลือกธนาคาร</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>หมายเลขบัญชี{/*  <font className="text-danger">*</font> */}</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='bankAccNo' onChange={(e) => setBankAccNo(e.target.value)} 
                                                value={bankAccNo} placeholder='หมายเลขบัญชี'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1 }} />
                                            {bankAccNoErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณากรอกเลขบัญชีธนาคาร (เฉพาะตัวเลขเท่านั้น)</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4}}><strong>สำเนาหน้าสมุดบัญชี</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            {bookBankUrl &&
                                            <a href={bookBankUrl} target='_blank' style={{ marginBottom: 5, marginLeft: 5}}><img src={bookBankUrl} alt="WEEE" className='img-fluid' style={{ width: 200 }} /></a>
                                            }
                                            <input ref={inputBookBankRef} className="form-control file" id="bookbank_image" type="file" accept="image/*" onChange={(e) => handleImageBookBank(e.target.files[0])} />
                                            {imageBookBankSizeError &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** ขนาดรูปภาพต้องไม่เกิน 1MB</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div className="d-none d-md-block d-lg-block" style={{ minWidth: 20 }}>&nbsp;</div>
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 4 }}>
                                <div style={{ marginBottom: 10, paddingTop: 5, borderBottom: '1px solid #cccccc' }}>
                                    <h6><TbHome style={{ fontSize: 25, marginRight: 5, paddingBottom: 5 }} />
                                    <b>ข้อมูลที่อยู่</b></h6>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10, paddingRight: 15}}>
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>บ้านเลขที่</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='address' onChange={(e) => setAddress(e.target.value)} 
                                                value={address} placeholder='บ้านเลขที่'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>หมู่บ้าน/สถานที่</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='village' onChange={(e) => setVillage(e.target.value)} 
                                                value={village} placeholder='หมู่บ้าน/สถานที่'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>อาคาร</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='building' onChange={(e) => setBuilding(e.target.value)} 
                                                value={building} placeholder='อาคาร'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ชั้น</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='floor' onChange={(e) => setFloor(e.target.value)} 
                                                value={floor} placeholder='ชั้น'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ห้อง</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='room' onChange={(e) => setRoom(e.target.value)} 
                                                value={room} placeholder='ห้อง'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ซอย</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='subroad' onChange={(e) => setSubRoad(e.target.value)} 
                                                value={subroad} placeholder='ซอย'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ถนน</strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='road' onChange={(e) => setRoad(e.target.value)} 
                                                value={road} placeholder='ถนน'
                                                style={{ paddingLeft: 8, marginRight: 5, display: 'flex', flex: 1, width: '100%' }} />
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>จังหวัด <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <select name='province' value={provinceId} onChange={(e) => { handleSelectProvince(e.target.value) }} style={{ paddingLeft: 8, paddingRight: 8, maxWidth: 250 }}>
                                                <option value="0">--- กรุณาเลือกจังหวัด ---</option>
                                                {provinceList?.map((province, i) => (
                                                <option value={province.data.province_id} key={province.data.province_id}>
                                                    {province.data.province_name}
                                                </option>
                                                ))}
                                            </select>
                                            {provinceIdErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณาเลือกจังหวัด</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>อำเภอ <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <select name='district' value={districtId} onChange={(e) => { handleSelectDistrict(e.target.value) }} style={{ paddingLeft: 8, paddingRight: 8, maxWidth: 250 }}>
                                                <option value="0" key="0">--- กรุณาเลือกอำเภอ ---</option>
                                                {districtList?.map((district, i) => (
                                                <option value={district.data.district_id} key={district.data.district_id}>
                                                    {district.data.district_name}
                                                </option>
                                                ))}
                                            </select>
                                            {districtIdErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณาเลือกอำเภอ</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>ตำบล <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <select name='subdistrict' value={subdistrictId} onChange={(e) => { handelSelectsubDistrict(e.target.value) }} style={{ paddingLeft: 8, paddingRight: 8, maxWidth: 250 }}>
                                                <option value="0">--- กรุณาเลือกตำบล ---</option>
                                                {subdistrictList?.map((subdistrict, i) => (
                                                <option value={subdistrict.data.subdistrict_id} key={subdistrict.data.subdistrict_id}>
                                                    {subdistrict.data.subdistrict_name}
                                                </option>
                                                ))}
                                            </select>
                                            {subdistrictIdErrorDiv &&
                                            <div className="text-danger border-danger" style={{ marginLeft: 10, marginTop: 5, flex: 1, display: 'flex' }}>
                                                <strong>** กรุณาเลือกตำบล</strong>
                                            </div>
                                            }
                                        </div>
                                    </div> 
                                    <div className="flex-container" style={{ display: 'flex', marginBottom: 7 }}>
                                        <label className="col-form-label" style={{ display: 'flex', flex: 4 }}><strong>รหัสไปรษณีย์ <font className="text-danger">*</font></strong></label>
                                        <div style={{ display: 'flex', flex: 5, flexDirection: 'column' }}>
                                            <input type='text' name='postcode' readOnly
                                                value={postcode} placeholder='รหัสไปรษณีย์'
                                                style={{ paddingLeft: 8, display: 'flex', flex: 1 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div style={{ width: 170 }} className="d-none d-md-block d-lg-block">&nbsp;</div>
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                                <div className="flex-container" style={{ marginBottom: 10, borderBottom: '1px solid #cccccc', borderTop: '1px solid #cccccc', marginTop: 15, display: 'flex' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                                        <h6 style={{ display: 'flex', flex: 1, marginTop: 11 }}><FaMapMarkerAlt style={{ fontSize: 20, marginLeft: 5, marginRight: 5 }} />
                                        <b>ตำแหน่งพิกัดที่พักอาศัย</b></h6>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: 5}}>
                                        <div style={{ float: 'right', marginTop: 5 }}>
                                            <button type="button" className="btn btn-success btn-sm" style={{ marginRight: 5, display: 'flex' }} onClick={() => { handleGoToCurrentPosition() }}>
                                                <FaMapMarkerAlt style={{ fontSize: 20, marginRight: 5 }} />ไปยังตำแน่งปัจจุบัน
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ marginBottom: 10, display: 'flex', flexWrap: 'nowrap' }}>
                                        <font className="text-danger" style={{ marginRight: 5 }}>**</font> ลาก Marker <FaMapMarkerAlt className='text-danger' style={{ fontSize: 20, marginLeft: 5, marginRight: 5 }} /> เพื่อกำหนดตำแหน่ง
                                    </div>
                                    <div><strong>Latitude:</strong> {lat}, <strong>Longitude:</strong> {lng}</div>
                                    <div className="mb-3 row" style={{ display: 'flex', height:400, flexDirection: 'column' }}>
                                        <div style={{  display: 'flex', flexWrap: 'nowrap', height:400, flex: 1 }}>
                                            {!isLoaded ? ( <h1>Loading...</h1> ) : (
                                            <GoogleMap mapContainerClassName="map-container" center={{ lat: lat, lng: lng }} zoom={17} >
                                                <MarkerF 
                                                    draggable={true} position={center}
                                                    onDragEnd={(e) => onMarkerDragEnd(e.latLng.lat, e.latLng.lng)}/>
                                            </GoogleMap>
                                            )}
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </>
)
}

export default EditProfile;